import {Random} from "@lib/utilities/Random";
import {Browser} from "@lib/browser/Browser";

export class AlarmTracker<TData>
{
  // NOTE (manfred.gold, 2024-04-15): Due to the reverse-look-up added with ANCWE-105, TData has to be unique, which currently is the case in all
  // usages of AlarmTracker (where the connectionID is used as TData), but has to be kept in mind for future usages of this class.
  private activeAlarms = new Map<string, TData>();
  private activeAlarmsByValue = new Map<TData, string>();

  public createAlarm(time: number, data: TData)
  {
    const alarmId = Random.generateGuid();
    this.activeAlarms.set(alarmId, data);
    this.activeAlarmsByValue.set(data, alarmId);

    Browser.alarms.create(alarmId, {
      delayInMinutes: time
    });
  }

  public tryGetAlarm(name: string): Nullable<TData>
  {
    const existingAlarm = this.activeAlarms.get(name);
    if (!existingAlarm)
      return null;
    
    this.activeAlarms.delete(name);
    this.activeAlarmsByValue.delete(existingAlarm);
    
    return existingAlarm;
  }
  
  public deleteAlarm(data: TData)
  {
    const alarmId = this.activeAlarmsByValue.get(data);
    if (!alarmId)
      return;
    
    this.activeAlarms.delete(alarmId);
    this.activeAlarmsByValue.delete(data);
  }
}